import { useLanguage } from '../i18n/LanguageContext';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const LanguageSelector = ({ className = "" }) => {
  const { language, setLanguage, availableLanguages } = useLanguage();
  
  const currentLang = availableLanguages.find(l => l.code === language);

  return (
    <Select value={language} onValueChange={setLanguage}>
      <SelectTrigger className={`w-auto min-w-[50px] md:min-w-[140px] bg-transparent border-white/20 text-white hover:bg-white/10 ${className}`}>
        <Globe className="w-4 h-4 mr-1 md:mr-2 text-[#D4AF37] flex-shrink-0" />
        <span className="flex items-center gap-1 md:gap-1.5">
          <span>{currentLang?.flag}</span>
          <span className="hidden md:inline">{currentLang?.name}</span>
        </span>
      </SelectTrigger>
      <SelectContent>
        {availableLanguages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
